export default "__VITE_ASSET__CVHcLZx7__"